import type { FC } from "react";

import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";
import { Button, Flex, Image } from "~/shared/ui-kit";
import { useDirectus } from "~/shared/utils/directus/useDirectus";

import type { FooterV3Props } from "../FooterV3";

export const FooterControls: FC<FooterV3Props> = ({
  isControlInactive,
  onCallAction,
  getUrl,
  data,
}) => {
  const { getDirectusImage } = useDirectus();
  return (
    <Flex
      flexWrap="wrap"
      className="max-w-[312px] md:max-w-full mx-auto my-10"
      justify="center"
      gap={16}
    >
      {data?.controls?.map((control) => {
        const controlAction = control?.footer_controls_id?.action;
        const action = controlAction?.action?.[0];
        const isInactive = controlAction
          ? isControlInactive(controlAction)
          : true;

        let href;
        if (isExternalLink(action?.item)) {
          href = action.item.href ?? undefined;
        }
        if (isInternalLink(action?.item)) {
          href = action.item.page ? getUrl(action.item.page) : undefined;
        }
        const handlePressButton = (): void => {
          if (action) {
            onCallAction(action);
          }
        };
        return (
          !isInactive && (
            <Button
              href={href}
              onPress={handlePressButton}
              key={control?.id}
              variant="secondary"
              className="p-2.5 max-w-[100px] max-h-12  border-white/25 border "
            >
              <Image
                value={getDirectusImage(
                  control?.footer_controls_id?.icon?.id ?? "",
                  {
                    format: "webp",
                    width: 82,
                  },
                )}
                className="py-5 md:py-10"
              />
            </Button>
          )
        );
      })}
    </Flex>
  );
};
